import { brandContentRO } from './ro';
import { brandContentEN } from './en';
import { brandContentDE } from './de';
import { BrandContent } from './types';

export * from './types';

const brandContentByLanguage = {
  'ro': brandContentRO,
  'ro-RO': brandContentRO,
  'en': brandContentEN,
  'en-GB': brandContentEN,
  'en-US': brandContentEN,
  'de': brandContentDE,
  'de-DE': brandContentDE,
};

/**
 * Get brand content for a specific language
 * @param language Language code (e.g., 'ro', 'en-GB', 'de-DE')
 * @returns Brand content map for the specified language
 */
export const getBrandContent = (language: string) => {
  const normalizedLang = language.toLowerCase();
  return brandContentByLanguage[normalizedLang as keyof typeof brandContentByLanguage] || brandContentRO;
};

/**
 * Get content for a specific brand in a specific language
 * @param brand Brand name (e.g., 'dacia', 'bmw')
 * @param language Language code
 * @returns Brand content or undefined if not found
 */
export const getBrandContentByName = (brand: string, language: string): BrandContent | undefined => {
  const content = getBrandContent(language);
  return content[brand.toLowerCase()];
};

// Legacy export for backwards compatibility
export const brandContent = brandContentRO;
